import { useState, useEffect, useCallback, useMemo } from 'react';
import { DataGridPro, GridInputRowSelectionModel, GridColDef } from '@mui/x-data-grid-pro';
import { SubMenu } from './SubMenu';
import { useTranslation } from 'react-i18next';
import { TimekeeperService } from 'services/TimekeeperService';
import { AccrualRule } from 'repository/timekeeper/@types/AccrualRule';

const AccrualRulesTable = () => {
    const { t } = useTranslation();
    const [rows, setRows] = useState<any[]>([]);
    const [loading, setLoading] = useState(false);
    const [selectedAccrualRule, setSelectedAccrualRule] = useState<GridInputRowSelectionModel | undefined>([]);
    const [contextMenu, setContextMenu] = useState<{ mouseX: number; mouseY: number } | null>(null);
    const [selected, setSelected] = useState<any>([]);

    const timekeeperService = useMemo(() => new TimekeeperService(), []);

    const columns: GridColDef[] = [
        { field: 'name', headerName: t("accruals.accrual_rules.table.columns.name"), flex: 1 },
        { field: 'accrual_code', headerName: t("accruals.accrual_rules.table.columns.accrual_code"), flex: 1 },
        {
            field: 'type_accrual',
            headerName: t("accruals.accrual_rules.table.columns.type_accrual"),
            flex: 1,
            headerAlign: 'center',
            align: 'center',
            valueGetter: (value, row) => row.type_accrual || '-'
        },
    ];

    const reloading = useCallback(() => {
        setLoading(true);
        timekeeperService.accrual_rule.getAll()
            .then((data: AccrualRule[]) => {
                //console.log(`Código de acumulación obtenido:`, data);
                setRows(data)
            })
            .catch((error) => {
                console.error('Error al obtener las reglas de acumulación:', error);
                setRows([]);
            })
            .finally(() => {
                setLoading(false);
            });
    }, [timekeeperService.accrual_rule]);

    useEffect(() => {
        reloading();
    }, [reloading]);

    const cleanSelected = () => {
        setSelected([]);
        setSelectedAccrualRule([]);
    }

    return (
        <div style={{ width: '100%', height: '100%' }}
            onContextMenu={(event) => {
                event.preventDefault();
                setContextMenu(contextMenu === null ? { mouseX: event.clientX + 2, mouseY: event.clientY - 6 } : null)
            }}
        >
            <DataGridPro
                sx={{ height: 'calc(100vh - 140px)' }}
                columns={columns}
                rows={rows}
                loading={loading}
                rowSelectionModel={selectedAccrualRule}
                pagination
                onRowSelectionModelChange={(newRowSelectionModel) => {
                    let row = rows.filter((row) => newRowSelectionModel.includes(row.id))
                    setSelectedAccrualRule(newRowSelectionModel);
                    setSelected(row);

                }}
                checkboxSelection
                localeText={
                    {
                        headerFilterOperatorContains: t('general.table.headerFilters.headerFilterOperatorContains'),
                        headerFilterOperatorEquals: t('general.table.headerFilters.headerFilterOperatorEquals'),
                        headerFilterOperatorStartsWith: t('general.table.headerFilters.headerFilterOperatorStartsWith'),
                        headerFilterOperatorEndsWith: t('general.table.headerFilters.headerFilterOperatorEndsWith'),
                        headerFilterOperatorIsEmpty: t('general.table.headerFilters.headerFilterOperatorIsEmpty'),
                        headerFilterOperatorIsNotEmpty: t('general.table.headerFilters.headerFilterOperatorIsNotEmpty'),
                        footerRowSelected: (count) =>
                            count > 1 ? `${count.toLocaleString()} filas seleccionadas`
                                : `${count.toLocaleString()} fila seleccionada`,

                        footerTotalRows: t('general.table.footerFilters.footerTotalRows'),
                        MuiTablePagination: {
                            labelDisplayedRows: ({ from, to, count }) =>
                                `${from} - ${to} of ${count === -1 ? `more than ${to}` : count}`,
                            labelRowsPerPage: t('general.table.footerFilters.labelRowsPerPage'),
                        },
                    }
                }
                showCellVerticalBorder
                showColumnVerticalBorder
                disableColumnMenu
                headerFilters
                slotProps={{
                    toolbar: {
                        showQuickFilter: true,
                    }
                }}
            />
            <SubMenu
                selected={selected}
                cleanSelected={cleanSelected}
                rows={rows}
                contextMenu={contextMenu}
                setContextMenu={setContextMenu}
                reloading={reloading}
            />
        </div>
    );
}

export { AccrualRulesTable };